import React from 'react'
import storyOptions from '../../Courses/Create/nestedComponents/PageConstructor/internal/PageMaker/components/Story/storyFormOptions.js'
import { Button, Form, Icon, Input, Modal, Tooltip } from 'antd'
import { formatLabel } from '../../Courses/Create/nestedComponents/PageConstructor/internal/PageMaker/utils/index.js'
import { CreatableSelect } from '../../../components/index.js'
const StoryModal = ({ form, setStoryMode, visible, onCancel }) => {
  const {
    getFieldDecorator,
    validateFields,
    getFieldsValue,
    getFieldValue,
    setFieldsValue
  } = form
  const handleStoryMode = e => {
    e.preventDefault()

    form.validateFields((err, values) => {
      if (!err) {
        setStoryMode(values)
      } else {
        console.log('❌ Validation errors:', err)
      }
    })
  }
  return (
    <Modal
      width={800}
      title={'Story Preferences'}
      centered
      visible={visible}
      onCancel={onCancel}
      footer={null}
      className={'story-preferences'}
    >
      <Form className="story-course-form" onSubmit={handleStoryMode}>
        {Object.entries(storyOptions).map(([key, values]) => (
          <Form.Item
            labelAlign="top"
            label={
              <span className="story-course-form-label">
                <span>{formatLabel(key)} </span>
                <Tooltip title={values.description}>
                  <Icon type="info-circle" />
                </Tooltip>
              </span>
            }
            key={key}
          >
            {getFieldDecorator(key, {
              rules: [
                {
                  required: true,
                  message: `Please input your ${formatLabel(key)}!`
                }
              ]
            })(
              values.value && values.value.length > 0 ? (
                <CreatableSelect
                  fieldKey={key}
                  updateOptionValue={(value, field) =>
                    form.setFieldsValue({ [field]: value })
                  }
                  options={values.value}
                  placeholder={`Select or type your ${formatLabel(key)}`}
                />
              ) : (
                <Input.TextArea
                  placeholder={`Enter your ${formatLabel(key)}`}
                />
              )
            )}
          </Form.Item>
        ))}
        <div className="form-button-center">
          <Form.Item>
            <Button
              className="shl-primary-btn"
              htmlType="submit"
              shape="round"
              size="large"
            >
              Confirm Mode
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}
export default Form.create()(StoryModal)
